export default "__VITE_ASSET__DmgqG8ee__"